module.exports = __webpack_public_path__ + "img/mcampos.867fed8a.svg";